import { useRouter } from 'next/router';

import { Box, Container, Typography, Grid, Button } from '@mui/material';
import { makeStyles, withStyles } from '@mui/styles';

import ArrowBackIosIcon from '@mui/icons-material/ArrowBackIos';

const useStyles = makeStyles(() => ({
    bttn: {
        backgroundColor: 'whitesmoke',
        padding: '6px 10px',
        color: '#0078f6',
        margin: 0,
        '& .MuiButton-startIcon': {
            margin: '0px !important',
        },
    },
    bttnIcon: {
        fontSize: '14px !important',
        marginTop: -1,
    },
}));

export default function BackButton(props) {
    const classes = useStyles();
    const router = useRouter();

    const handleClick = () => {
        if (props.onClick) props.onClick();
        else router.back();
    };

    return (
        <Button
            className={classes.bttn}
            onClick={handleClick}
            startIcon={<ArrowBackIosIcon className={classes.bttnIcon} />}
        >
            Буцах
        </Button>
    );
}
